import type { PriceTable } from "@/services/adminModelCurrency";
import { priceFootnote } from "./helpers";

/** Small note on where prices come from; hidden when the API sent no price table. */
const PriceFootnote = ({ priceTable }: { priceTable: PriceTable | undefined }) =>
  priceTable ? (
    <p className="text-xs text-muted-foreground">
      {priceFootnote(priceTable.asOf, priceTable.source)}
    </p>
  ) : null;

export default PriceFootnote;
